module.exports = __webpack_public_path__ + "static/kam-chauhan-social-media-122-85b32244aadf48d95e4fa1301f781fe5.jpg";